import { apiPost } from '@/services/api/client';

export type PatientSnapshot = {
  firstName: string;
  lastName: string;
  dob: string;
  healthCard: string;
  healthCardExp: string;
  sex: string;
  civ: string;
  dx: string;
  notes: string;
};

export type PairingCodeResponse = {
  code: string;
  expiresAt: string;
};

export type InitiateTransferResponse = {
  transferId: string;
};

export async function requestPairingCode(): Promise<PairingCodeResponse> {
  return apiPost('transfer/request-code', {});
}

export async function initiateTransfer(args: {
  code: string;
  patientIds: string[];
  patientSnapshots: PatientSnapshot[];
}): Promise<InitiateTransferResponse> {
  return apiPost('transfer/initiate', args);
}

export async function respondToTransfer(args: {
  transferId: string;
  action: 'accept' | 'decline';
}): Promise<void> {
  return apiPost('transfer/respond', args);
}

export async function cancelTransfer(transferId: string): Promise<void> {
  return apiPost('transfer/cancel', { transferId });
}
